import {CreatePolicy, InsurePolicy, InsurerId, SortBy, UpdateDocument} from '../../Config/dataModel';
import {authRequest} from './request';

const allPolicies = (data: SortBy) => {
    return authRequest({
        url: '/coverNote/getPolicy',
        method: 'PUT',
        data
    });
};

const policyCount = (data: InsurerId) => {
    return authRequest({
        url: '/coverNote/getPolicyCount',
        method: 'PUT',
        data
    });
};

const insurerApplyPY = (data: CreatePolicy) => {
    return authRequest({
        url: '/coverNote/insurer/applyPolicy',
        method: 'PUT',
        data
    });
};

const insurerInsurePY = (ref: string, data: InsurePolicy) => {
    return authRequest({
        url: `/coverNote/insurer/insurePolicy/${ref}`,
        method: 'PUT',
        data
    });
};

const updatePolicy = (ref: string, data: UpdateDocument) => {
    return authRequest({
        url: `/coverNote/insurer/updatePolicy/${ref}`,
        method: 'PUT',
        data
    });
};

const policyAPI = {allPolicies, policyCount, insurerApplyPY, insurerInsurePY, updatePolicy};

export default policyAPI


// WEBPACK FOOTER //
// ./src/ReduxRequests/APIs/policyAPI.ts